import axios from 'axios';
import qs from 'qs';
import { getApiHeaderNotTime } from './../services/getApiHeaders';

export function login(data) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/token',
        data: qs.stringify(data),
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }

    return axios(options)
}

export function logout(data) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/user/logout',
        headers: getApiHeaderNotTime(),
        withCredentials: true,
        data: qs.stringify(data)
    }

    return axios(options)
}

export function getNews(data) {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/news/getbynumber?number=8',
        withCredentials: true,
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }

    return axios(options)
}

export function getBanners(data){
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/banners',
        withCredentials: true,
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }

    return axios(options)
}


// WEBPACK FOOTER //
// ./src/utils/login.js